import { router } from 'expo-router';
import {
    CircleUserRoundIcon,
    Icon,
    OpenDevDashboardButton,
    View,
    XStack,
} from 'smoothie';

import { IS_DEV } from '../../config/FruitfulEnvironment';
import { MessagingBadgeButton } from './MessagingBadgeButton';

export type HeaderHomeContext = 'headerNavbar' | 'topNavbar';
export type TabHeaderContext = 'default' | 'onboarding';

interface TabHeaderButtonsProps {
    showMessaging?: boolean;
    context?: TabHeaderContext;
}

export const TabHeaderButtons = ({
    showMessaging = true,
    context = 'default',
}: TabHeaderButtonsProps) => {
    return (
        <XStack gap={8} alignItems="center">
            <OpenDevDashboardButton hidden={!IS_DEV} />
            {showMessaging && <MessagingBadgeButton />}
            {context !== 'onboarding' && <OpenSettingsButton />}
        </XStack>
    );
};

const OpenSettingsButton = () => {
    return (
        <View
            paddingHorizontal={8}
            marginRight={-4} // offsets right padding so space between content and screen edge is consistent with page content
            onPress={() => {
                router.navigate('/settings');
            }}
            cursor="pointer"
        >
            <Icon icon={CircleUserRoundIcon} color="$black" />
        </View>
    );
};
